import {
  Modal,
  ModalBody,
  ModalHeader,
  CardBody,
  CardTitle,
  Form
  // @ts-ignore
} from 'reactstrap'
import { IconX, IconEdit } from '@tabler/icons-react'
//@ts-ignore
import { Button, Input } from 'dsm-react-lib'
import { useForm } from 'react-hook-form'
import { useEffect, useRef } from 'react'
import { useChatService } from '../services/chatService'

interface RenameChatModalProps {
  isOpen: boolean
  toggle: () => void
  chatTitle: string
  setChatTitle: (chatTitle: string) => void
  onRenameChat: any
}

const RenameChatModal: React.FC<RenameChatModalProps> = ({
  isOpen,
  toggle,
  chatTitle,
  setChatTitle,
  onRenameChat
}) => {
  const { register, errors, trigger, handleSubmit } = useForm({})
  const inputRef = useRef<HTMLInputElement | null>(null)
  const { isUpdatingChatTitle } = useChatService()

  useEffect(() => {
    if (isOpen) {
      const timeoutId = setTimeout(() => {
        if (inputRef.current) {
          const input = inputRef.current
          input.focus()
          input.setSelectionRange(input.value.length, input.value.length)
        }
      }, 1)
      return () => clearTimeout(timeoutId)
    }
  }, [isOpen])

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    const isValid = await trigger()
    if (isValid) {
      await onRenameChat()
      toggle()
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className={`!justify-between !border-0 !flex !items-center chat-primary theme-bg`}
        toggle={toggle}
        data-testid="closeBtn"
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconEdit className="me-1" color="white" />
          <span className="text-white">Rename Chat?</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1">
        <CardBody className="px-0 py-1 mx-1">
          <CardTitle tag="h4">What would you like to name this chat? </CardTitle>
          <Form onSubmit={handleSubmit(onSubmit)} className="pt-1">
            <Input
              type="text"
              id="chatTitle"
              name="chatTitle"
              defaultValue={chatTitle}
              ref={(e: any) => {
                register(e, {
                  required: 'Chat title is mandatory',
                  validate: (value) => value.trim() !== '' || 'Chat title cannot be blank'
                })
                inputRef.current = e
              }}
              invalid={'chatTitle' in errors}
              placeholder="Chat title"
              onChange={async (e: any) => {
                const trimmedValue = e.target.value.trim()
                await trigger('chatTitle')
                setChatTitle(trimmedValue)
              }}
              helperText={errors.chatTitle ? errors.chatTitle.message : ''}
              data-testid="chatTitle"
            />
            <div className={`flex justify-between mb-0 mt-2 chat-primary`}>
              <Button label="Cancel" variant="flat" onClick={toggle}></Button>
              <Button
                label={isUpdatingChatTitle ? 'Saving' : 'Rename'}
                color="success"
                className="me-0"
                onClick={onSubmit}></Button>
            </div>
          </Form>
        </CardBody>
      </ModalBody>
    </Modal>
  )
}

export default RenameChatModal
